import { takeLatest, put, call } from 'redux-saga/effects';
import {
    setLoading,
    setCoursewareActivityList
} from '@store/reducers/scoringReducer';
import { resourceService } from '@libs/axios';
import {
    fetchListCoursewareActivity
} from '@store/actions/scoringActions';
import { ResponseType } from '@store/index';
const API_URL = process.env.REACT_APP_API_URL;

function* fetchCoursewareActivityListData(action: ReturnType<typeof fetchListCoursewareActivity>) {
    const { filters } = action.payload || {};
    yield put(setLoading(true));
    const params: any = {
        ...filters,
    };

    try {
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + '/api/courseware-activity/', {
            params
        }
        );

        if (response?.data) {
            yield put(setCoursewareActivityList(response.data));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        let error: Error = e;
        console.log(error);
    }
}

function* scoringSaga() {
    yield takeLatest(fetchListCoursewareActivity, fetchCoursewareActivityListData);
}

export default scoringSaga;